// color-sets.ts

export const colorSets = [
    {
        primary: '#ffb233',
        background: '#24252a',
        subHeaderColor: '#00020a',
        tableBG: '#000000',
        textColor: '#ffffff',
        tableHead: '#313236'
    },
    {
        primary: '#20d876',
        background: '#24252a',
        subHeaderColor: '#00020a',
        tableBG: '#00024a',
        textColor: '#ffffff',
        tableHead: '#313236'
    },
    {
        primary: '#f9a010',
        background: '#000000',
        subHeaderColor: '#00020a',
        tableBG: '#323131',
        textColor: '#ffffff',
        tableHead: '#4f51c2'
    },
    {
        primary: '#faab29',
        background: '#24252a',
        subHeaderColor: '#00020a',
        tableBG: '#00024a',
        textColor: '#ffffff',
        tableHead: '#313236'
    }
];


export const colorKeys = ['primary', 'background', 'subHeaderColor', 'tableBG', 'textColor', 'tableHead'];

export const events = [{
    "awayScore": 134,
    "homeScore": 0,
    "openDate": 1692343800000,
    "providerName": "SportRadar",
    "sportId": "sr:sport:21",
    "sportName": "Cricket",
    "competitionId": "sr:tournament:37597",
    "competitionName": "India / T20 Maharaja Trophy",
    "eventId": "sr:match:42879625",
    "eventName": "Namma Shivamogga vs. Mysuru Warriors",
    "status": "IN_PLAY",
    "eventStatus": "",
    "runner1": "Namma Shivamogga",
    "runner2": "Mysuru Warriors",
    "odds": ["1.71","2.91"],
    "limits":[
        {
            "back":"1.46",
            "lay":"1.36",
        },
        {
            "back":"1.26",
            "lay":"1.96",
        },
        {
            "back":"1.56",
            "lay":"1.76",
        },
    ]
},
  {
    "awayScore": 0,
    "homeScore": 0,
    "openDate": 1692349200000,
    "providerName": "SportRadar",
    "sportId": "sr:sport:21",
    "sportName": "Cricket",
    "competitionId": "sr:tournament:36805",
    "competitionName": "Simulated Reality League / Pakistan Super League SRL",
    "eventId": "sr:match:42584191",
    "eventName": "Quetta Gladiators Srl vs. Peshawar Zalmi SRL",
    "marketId": "",
    "status": "UPCOMING",
    "eventStatus": "",
    "runner1": "Quetta Gladiators Srl",
    "runner2": "Peshawar Zalmi SRL",
    "odds": ["1.71","2.91"],
    "limits":[
        {
            "back":"1.46",
            "lay":"1.36",
        },
        {
            "back":"1.26",
            "lay":"1.96",
        },
        {
            "back":"1.56",
            "lay":"1.76",
        },
    ]
},
{
  "awayScore": 0,
  "homeScore": 0,
  "openDate": 1692399600000,
  "providerName": "SportRadar",
  "sportId": "sr:sport:21",
  "sportName": "Cricket",
  "competitionId": "sr:tournament:36807",
  "competitionName": "Simulated Reality League / T20 International SRL",
  "eventId": "sr:match:42584031",
  "eventName": "Sri Lanka Srl vs. Bangladesh Srl",
  "marketId": "",
  "status": "UPCOMING",
  "eventStatus": "",
  "runner1": "Sri Lanka Srl",
  "runner2": "Bangladesh Srl",
  "odds": ["1.71","2.91"],
  "limits":[
    {
        "back":"1.46",
        "lay":"1.36",
    },
    {
        "back":"1.26",
        "lay":"1.96",
    },
    {
        "back":"1.56",
        "lay":"1.76",
    },
]
 
},{
"awayScore": 0,
"homeScore": 0,
"openDate": 1692408600000,
"providerName": "SportRadar",
"sportId": "sr:sport:21",
"sportName": "Cricket",
"competitionId": "sr:tournament:33207",
"competitionName": "Simulated Reality League / Big Bash League SRL",
"eventId": "sr:match:42584429",
"eventName": "Sydney Sixers SRL vs. Adelaide Strikers Srl",
"marketId": "",
"status": "UPCOMING",
"eventStatus": "",
"runner1": "Sydney Sixers SRL",
"runner2": "Adelaide Strikers Srl",
"odds": ["1.71","2.91"],
"limits":[
    {
        "back":"1.46",
        "lay":"1.36",
    },
    {
        "back":"1.26",
        "lay":"1.96",
    },
    {
        "back":"1.56",
        "lay":"1.76",
    },
]
},]

export const markets = [{
    "market": "1st innings - Middlesex total fours",
    "runners":[
        {
            "runner": "over 18.5",
            "price":"1.36",
        },
        {
            "runner": "under 18.5",
            "price":"1.78",
        },
    ]
},
{
    "market": "Draw no bet",
    "runners":[
        {
            "runner": "Middlesex",
            "price":"1.36",
        },
        {
            "runner": "Warwickshire",
            "price":"1.78",
        },
    ]
},
{
    "market": "1st innings over 26 - Middlesex total",
    "runners":[
        {
            "runner": "over 2.5",
            "price":"5.55",
        },
        {
            "runner": "under 2.5",
            "price":"0.98",
        },
    ]
},{
    "market": "1st innings over 27 - Middlesex total",
    "runners":[
        {
            "runner": "over 2.5",
            "price":"4.56",
        },
        {
            "runner": "under 2.5",
            "price":"3.18",
        },
    ]
},{
    "market": "1st innings over 28 - Middlesex total",
    "runners":[
        {
            "runner": "over 18.5",
            "price":"2.36",
        },
        {
            "runner": "under 18.5",
            "price":"1.38",
        },
    ]
},{
    "market": "Team with highest score at 1st dismissal",
    "runners":[
        {
            "runner": "Middlesex",
            "price":"6.26",
        },
        {
            "runner": "Warwickshire",
            "price":"4.78",
        },
    ]
},
]
